export default __webpack_public_path__ + "static/VectorTablet-bf40b06b65b0a8fd60f374c1e94f7b60.png";